<template>
  <v-layout fill-height style="width:100%;height:100%;pointer-events:none;">

    <drop
      @dragleave="ResetHoverHighlight"
      @drop="OnDrop"
      @dragover="DragOverCanvas"
    >
      <babylon-panel
        id="MainPanel"
        ref="mainCanvas"
        style="height:100%; width:100%;position: absolute;pointer-events:auto;"
        @init=OnInit
      />
    </drop>

    <div style="height:100%;width:100%;position:absolute;" class="pa-4">
      <v-btn style="position: absolute;right:10px;bottom:10px;pointer-events:auto;" small fab  :color="(editMode) ? 'blue' : 'black'" @click="editMode = !editMode" ><v-icon>mdi-pencil</v-icon>></v-btn>
    </div>


    <model-editor
    style="height:100%;width:100%;position:absolute;"
    v-on:OnChangedModel="OnResourceDataChanged"
    v-on:OnRemoveVideoMaterial="RemoveVideoMaterialAtIndex"
    v-model="resourceData"
    v-if="editMode"
    />

    <v-card color="black" width="100%" height="100%" v-if="!loadedModel || !updatingData && !loadedModel">
      <v-row style="height:100%;" align="center" justify="center">
        <v-col cols="auto">
          <v-progress-circular indeterminate large/>
        </v-col>
      </v-row>
    </v-card>

  </v-layout>
</template>

<script>

import axios from 'axios'
import { mapActions } from 'vuex'
import { mapState} from 'vuex'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import BabylonPanel from '@/components/Babylon/Panels/BabylonPanel.vue'

import ModelEditor from '@/components/Babylon/Panels/ModelEditor.vue'

import CONFIG from '@/appconfig.json'
import { GetAuthorisationHeaderGroup} from '@/vuex/assetxphelpers'


export default {
  name: 'FocusedItem',
  components: {

    ModelEditor,
    BabylonPanel
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    babylonPanelIdentifier: {
      type: String,
      default: null,
    },
    resource: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters("sessionState", [
        "GetBabPnl"
    ]),
    ...mapState("assetxpstate", [
        "asset"
    ]),
    ...mapGetters("authentication", [
        "sasToken"
    ])
  },

  created () {

   

  },
  data: () => ({

    initalized : false,
    loadedModel : false,
    editMode : false,
    updatingData : false,
    resourceData : { videoMaterials : []},
    lastPickedMaterialId : null,
    lastPickedMaterialAlbedo : null
     
  }),
  methods: {

    ...mapActions("assetxpstate", [
        "UpdateResourceData"
    ]),

    ...mapMutations("sessionState", [
      "SetResourceArrowVisibility"
    ]),

    OnDrop(dropData,event)
    {
      this.ResetHoverHighlight();
      var inst = this.GetBabPnl('MainPanel');

      var rect = this.$refs.mainCanvas.$el.getBoundingClientRect()
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;

      var pickRay = inst.scene.createPickingRay(x, y, BABYLON.Matrix.Identity(), inst.scene.activeCamera);	
      var hit = inst.scene.pickWithRay(pickRay);
      
      if(hit.pickedMesh != null)
      {
        console.log("Got drop event");
        console.log("Drop data", dropData);

        if(dropData != null)
        {
          if(dropData.detailid != null)
          {
            axios.get(CONFIG.platformEndpoints.assetxpapi +  'asset/getbasic/' + dropData.detailid,GetAuthorisationHeaderGroup())
            .then( (response) => {

              console.log("Fetched asset data",response.data);

              let asset = response.data;

              if(asset.resources != null)
              {
                let videoRes = asset.resources.find(res => res.url.includes("mp4"))

                if(videoRes != null)
                {
                  // Found a video res, therefore link this asset id and resource id to a video overide object
                  this.AddVideoMaterialForMaterial(hit.pickedMesh.material,asset,videoRes.id);
                }
              }
            })
            .catch((error) => {

              console.log("Error with fetching asset",error);

            });
          }
        }
      }
    },
    AddVideoMaterialForMaterial(material, videoAsset, resourceId)
    {
      if(this.resourceData.videoMaterials == null)
        this.$set(this.resourceData,"videoMaterials", []);

      let assignment = this.resourceData.videoMaterials.find(videoMat => videoMat.materialId == material.id);

      if(assignment != null)
      {
        //Bail if this is just the same
        if(assignment.targetMaterialName == material.name && assignment.videoAsset.assetDetailid == videoAsset.assetDetailid && resourceId == assignment.videoAssetResourceId)
          return;

        assignment.targetMaterialName = material.name;
        assignment.videoAssetId = videoAsset.assetDetailid;
        assignment.videoAssetResourceId = resourceId;
      }
      else
      {
        assignment = {targetMaterialName : material.name, videoAssetId : videoAsset.assetDetailid, videoAssetResourceId : resourceId};
        this.resourceData.videoMaterials.push(assignment);
      }

      this.CreateVideoTextureForAssignment(assignment,true);
    },
    async CreateVideoTextureForAssignment(videoMatAssignment,updateOnFetch)
    {
      console.log("Creating video texture for assignment", videoMatAssignment);
      // Get the material
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);

      console.log("scene materials",inst.scene.materials.length);

      let matchingMaterial = inst.scene.materials.find(mat => mat.name == videoMatAssignment.targetMaterialName);

      if(matchingMaterial != null)
      {
        // Material does exist, so lets get the asset

        await axios.get(CONFIG.platformEndpoints.assetxpapi +  'asset/getbasic/' + videoMatAssignment.videoAssetId,GetAuthorisationHeaderGroup())
        .then( (response) => {

          console.log("Fetched asset data",response.data);

          let asset = response.data;

          if(asset.resources != null)
          {
            // First find the matching specified resource if possible

            let foundResById = asset.resources.find(res => res.id == videoMatAssignment.videoAssetResourceId);

            if(foundResById == null)
            {
              foundResById = asset.resources.find(res => res.url.includes("mp4"))
            }

            if(foundResById != null)
            {
              console.log("Assigning vid Tex, check for existing");
              let vidTexture = inst.scene.textures.find(tex => tex.video != null && tex.video.src == foundResById.url);

              if(vidTexture == null)
              {
                vidTexture = new BABYLON.VideoTexture("video", foundResById.url + this.sasToken, inst.scene, true,true);
              }

              matchingMaterial.albedoTextureBackup = matchingMaterial.albedoTexture;
              matchingMaterial.emissiveTextureBackup = matchingMaterial.emissiveTexture;

              matchingMaterial.albedoTexture = vidTexture;
              matchingMaterial.emissiveTexture = vidTexture;

              console.log("Created texture", vidTexture);
              
              if(updateOnFetch)
              {
                this.UpdateResourceWithData(this.resourceData);
              }
            }
          }
        })
      }
    },
    OnInit()
    {
      if(!this.initalized)
      {
        var inst = this.GetBabPnl(this.babylonPanelIdentifier);
        this.CreateCamera();

        for (var k = 0; k < inst.scene.meshes.length; k++) {
          var mesh = inst.scene.meshes[k];
          mesh.isPickable = false;
        }


        this.LoadModel();
        this.initalized = true;
      }
    },
    CreateCamera()
    {
        console.log("Creating camera");
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);
      const radius = 0.04413892468931263;
      const camera = new BABYLON.ArcRotateCamera("default camera", 1.6, 1.6, radius, BABYLON.Vector3.Zero(), inst.scene);


      camera.wheelPrecision = 100/radius;
        camera.minZ = 0.0005156552065139548;//radius * 0.01;
        camera.maxZ = 51.565520651395474;//radius * 1000;
        camera.speed = 0.010313104130279097;//radius * 0.2;
        inst.scene.activeCamera = camera;
   

      camera.useFramingBehavior = true;

      var framingBehavior = camera.getBehaviorByName("Framing");
      framingBehavior.framingTime = 0;
      framingBehavior.elevationReturnTime = -1;

      camera.lowerRadiusLimit = null;
      camera.framingBehavior.radiusScale = 1.15;

      camera.attachControl(inst.canvas, true);

      camera.inputs.attached.mousewheel.wheelPrecision = 500;
      inst.canvas.addEventListener('wheel', evt => evt.preventDefault());

      console.log("Camera Created");
      
    },
    LoadModel()
    {
      this.loadedModel = false;
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);
      const assetsManager = new BABYLON.AssetsManager(inst.scene);
      assetsManager.useDefaultLoadingScreen  = false;
      const meshTask = assetsManager.addMeshTask("Mesh Loader", "", this.resource.url + this.sasToken, "");

      var camera = inst.scene.activeCamera;

      BABYLON.SceneLoader.ImportMesh(null, this.resource.url + this.sasToken, "", inst.scene, (meshes) => {

        setTimeout(() => {
          console.log("Loaded mesh");
          var framingBehavior = inst.scene.activeCamera.getBehaviorByName("Framing");
          framingBehavior.zoomOnMeshHierarchy(meshes[0]);

          inst.scene.activeCamera.beta = 1.1;
          inst.scene.activeCamera.alpha = 2.3;

          if(this.resource.dataFileUrl != null)
          {
            this.GetResourceData(this.resource.dataFileUrl).then(() => {
              this.loadedModel = true;
            });
          }
          else
          {
            this.loadedModel = true;
          }

        },500)

      });
    },
    async GetResourceData(dataUrl)
    {
      console.log("Getting resource data",dataUrl)
      this.updatingData = true;
      await axios.get(dataUrl + this.sasToken,{params : { t : new Date().getTime()}})
      .then( async (response) => {

        console.log("Fetched resouce data",response.data);

        this.resourceData = response.data;
        this.updatingData = false;

        this.EnsureDefaultsForResData();

        for (let i = 0; i < this.resourceData.videoMaterials.length; i++) {
          let assignment = this.resourceData.videoMaterials[i];
          await this.CreateVideoTextureForAssignment(assignment,false);
        }
          
      })
      .catch(function (error) {

        console.log("Faield to fetch resoruce data",error);
        this.UpdateResourceWithData({});
      });
    },
    UpdateResourceWithData(dataObject)
    {
      console.log("Updating resource data");
      console.log(dataObject);

      var payload = {};

      payload.assetDetailId = this.asset.assetDetailid;
      payload.resourceId = this.resource.id;
      payload.json = JSON.stringify(dataObject);

      this.updatingData = true;
     
      this.UpdateResourceData(payload).then(() =>{

        this.updatingData = false;
        this.resourceData = dataObject;
        
      });
    },
    RemoveVideoMaterialAtIndex(index)
    {
      // Find material and restore texture
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);

      let usedMaterial = inst.scene.materials.find(mat => mat.id == this.resourceData.videoMaterials[index].targetMaterialName);
      if(usedMaterial != null)
      {
        // Check if any other materials are using these textures, if not lets remove them!
        
        let otherExistingMaterialUsesMaterials = inst.scene.materials.some(mat => mat != usedMaterial && mat.albedoTexture == usedMaterial.albedoTexture && mat.emissiveTexture == usedMaterial.emissiveTexture);

        if(!otherExistingMaterialUsesMaterials)
        {
          usedMaterial.albedoTexture.dispose();
          usedMaterial.emissiveTexture.dispose();
        }

        usedMaterial.albedoTexture = usedMaterial.albedoTextureBackup;
        usedMaterial.emissiveTexture = usedMaterial.emissiveTextureBackup;
      }

      this.resourceData.videoMaterials.splice(index,1);
      this.UpdateResourceWithData(this.resourceData);
    },
    OnResourceDataChanged()
    {
      console.log("Resource data changed",this.resourceData);
    },
    ResetHoverHighlight()
    {
      var inst = this.GetBabPnl('MainPanel');

      let lastUsedMat = inst.scene.materials.find(mat => mat.id == this.lastPickedMaterialId);
      if(lastUsedMat != null)
      {
        lastUsedMat.albedoColor = this.lastPickedMaterialAlbedo;
      }

      this.lastPickedMaterialAlbedo = null;
      this.lastPickedMaterialId = null;
    },
    DragOverCanvas(dropData,event)
    {
      console.log("Draging");

      var inst = this.GetBabPnl('MainPanel');

      var rect = this.$refs.mainCanvas.$el.getBoundingClientRect()
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;

      var pickRay = inst.scene.createPickingRay(x, y, BABYLON.Matrix.Identity(), inst.scene.activeCamera);	
      var hit = inst.scene.pickWithRay(pickRay);
      
      if(hit.pickedMesh != null)
      {
        if(hit.pickedMesh.material.id != this.lastPickedMaterialId && this.lastPickedMaterialId != null)
        {
          this.ResetHoverHighlight();
        }

        if(this.lastPickedMaterialId == null)
        {
          this.lastPickedMaterialAlbedo = hit.pickedMesh.material.albedoColor;
          this.lastPickedMaterialId = hit.pickedMesh.material.id;
        }

        hit.pickedMesh.material.albedoColor  = new BABYLON.Color3(1, 0, 1);
      }
      else
      {
        this.ResetHoverHighlight();
      }
    },
    EnsureDefaultsForResData()
    {
      if(this.resourceData.videoMaterials == null)
        this.$set(this.resourceData,"videoMaterials", []);
    }
  },
  watch: {
    editMode : {
      handler(editMode)
      {
        this.SetResourceArrowVisibility(!editMode);
      }
    }
  }
}
</script>
